import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

class PriceInput extends Component {

  handleChange = (e) => {
    let price = e.target.value;
    price = price.split(',').join('')
    this.props.onChange(price);
  }


  render() {
    const { onBlur, className, name, id, value, displayType } = this.props;
    return (
      <div className="price">
          <NumberFormat thousandSeparator={true} isNumericString allowNegative={false}
          defaultValue={value}
          name={name}
          id={id}
          onChange={this.handleChange}
          onBlur={onBlur}
          className={className}
          displayType={displayType}
          />
          <span className="rial"> ریال</span>
      </div>
    );
  }
}
export default PriceInput;
